import { ChangeEventHandler, Fragment, memo, useMemo, useState } from 'react';

import { isEmpty, isNonNullish } from 'remeda';
import useSWR from 'swr';

import { CasinoAdCard } from './casinoAdCard/CasinoAdCard';
import { CreateCasinoAdButton } from './createCasinoAdButton/CreateCasinoAdButton';

import css from './CasinoAds.module.css';

import { adsService } from 'v2/api/adsService';
import { Card } from 'v2/components/card/Card';
import { EmptyPlaceholder } from 'v2/components/emptyPlaceholder/EmptyPlaceholder';
import { Loader } from 'v2/components/loader/Loader';
import { SearchTextField } from 'v2/components/searchTextField/SearchTextField';

export const CasinoAds = memo(() => {
  const [search, setSearch] = useState('');

  const { data, isLoading, mutate } = useSWR('getCasinoAds', adsService.getCasinoAds);

  const searchedAds = useMemo(() => {
    if (isEmpty(search)) return data;

    return data?.filter((ad) => ad.name.includes(search));
  }, [search, data]);

  const handleSearch: ChangeEventHandler<HTMLInputElement> = (e) => {
    setSearch(e.target.value);
  };

  return (
    <Card className={css.casinoAdsListCard}>
      <div className={css.casinoAdsListCardHeader}>
        <SearchTextField value={search} onChange={handleSearch} label="Casino Ad" />

        <CreateCasinoAdButton onSuccess={mutate} />
      </div>

      {isLoading ? (
        <Loader />
      ) : (
        isNonNullish(searchedAds) && (
          <Fragment>
            {isEmpty(searchedAds) ? (
              <EmptyPlaceholder />
            ) : (
              <div className={css.casinoAdsList}>
                {searchedAds.map((casinoAd) => (
                  <CasinoAdCard key={casinoAd.id} casinoAd={casinoAd} onRevalidate={mutate} />
                ))}
              </div>
            )}
          </Fragment>
        )
      )}
    </Card>
  );
});

CasinoAds.displayName = 'CasinoAds';
